import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../../models/base/apivisa.model';
import { BaseService } from '../../../templates/services/base-service.template';
import { Core2Config } from '../../../utils/core2-config';
import { getHttpHeader } from '../../../utils/http-header.factory';
import { Pagination } from '../../../models/pagination/pagination.model';
import { PagingResponseModel } from '../../../models/base/paging-response.model';
import { ApiResponseModel } from '../../../models/base/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentProviderMaintenanceNoticeService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/payment-provider-announcement/backoffice-ep';

  constructor(protected readonly http: HttpClient) {}

  public post(data: any, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public delete(guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.delete<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }/${ guid }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getByCriteria(p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<any>>{
    return this.http.get<PagingResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }/query?${ p.toString() }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
